import { BaseStation, LorawanStation, StationType } from 'models/base-station';
import { useAuthUserSelector, useDialog } from 'hooks';
import { useStationResponsiblePersonsDictionary } from 'hooks/station';
import { canDeleteStation, canEditStation } from 'utils/permissions';
import { DetachStationLocation, DetachLorawanStationLocation } from 'actions/base-station';

// components
import { Button, Paper } from '@material-ui/core';
import { DetachLocationDialog, DeleteLocationDialog } from 'components/BaseStation/Dialogs';

// styles
import useStyles from './style';

interface Props {
  readonly station: BaseStation | LorawanStation;
}

export const StationBlock = ({ station }: Props): JSX.Element => {
  const classes = useStyles();
  const user = useAuthUserSelector();
  const detachDialog = useDialog();
  const deleteDialog = useDialog();

  const { handleResponsiblePersonsDataDictionary } = useStationResponsiblePersonsDictionary();

  return (
    <Paper className={ classes.stationLocationActions }>
      { !canEditStation(user) ? '' :
        <Button
          variant="text"
          className={ classes.buttonUnbind }
          onClick={ detachDialog.open }
        >
          Unbind location
        </Button>
      }
      { !canDeleteStation(user) ? '' :
        <Button
          variant="text"
          className={ classes.buttonDelete }
          onClick={ deleteDialog.open }
        >
          Remove location
        </Button>
      }

      { detachDialog.isMounted && <DetachLocationDialog
        station={ station }
        isOpen={ detachDialog.isOpen }
        onClose={ detachDialog.close }
        onCloseEnd={ detachDialog.unmount }
      />}
      { deleteDialog.isMounted && station.location && <DeleteLocationDialog
        location={ station.location }
        isOpen={ deleteDialog.isOpen }
        onClose={ deleteDialog.close }
        onCloseEnd={ deleteDialog.unmount }
        onDelete={ station.type === StationType.lorawan ? DetachLorawanStationLocation(station) : DetachStationLocation(station) }
        onDeleteCallback={ handleResponsiblePersonsDataDictionary }
      /> }
    </Paper>
  );
};
